/* eslint-disable import/extensions */
/* eslint-disable react/react-in-jsx-scope */
import { message } from 'antd';
import { getDeptTypeList } from '../../services/department/department';
import {
  getStudentList,
  delBatchs,
  searchList,
  batchAddDept,
} from '../../services/personnel/personnel';
import { userDetails } from '../../services/addressList/addressList';
import { getDeptTree } from '../../services/roleManage/inedx';
import { setSpinProps } from '@/utils/utils';
import { setNanoId } from '@/utils/nanoId';
import { setPersonnelTableHeader, setPersonnelTableData } from '../../utils/managementCenter';
import { loopArray } from '../../utils/loop';

// 转换数据结构
const getDeptTreeFun = deptTree => {
  if (!Object.getOwnPropertyNames(deptTree).length) {
    return [];
  }

  const newDeptTree = [Object.assign({}, deptTree)];

  loopArray({ list: newDeptTree, parentItem: null }, item => {
    const { deptId, deptName, isRoot, subDepts } = item;

    const newItem = item;

    newItem.title = deptName;
    newItem.value = deptId;
    newItem.key = deptId;
    if (isRoot) {
      newItem.isLeaf = isRoot === 0;
    }

    if (subDepts) {
      newItem.children = subDepts;
    }

    return { result: subDepts, parentItem: item };
  });

  newDeptTree.unshift({
    title: '全部部门',
    value: '',
    key: '',
  });

  return newDeptTree;
};

const initData = () => ({
  showSelectUserModal: false, // 选人组件
  columns: [
    // {
    //   title: '姓名',
    //   dataIndex: 'deptName',
    // },
    // {
    //   title: '岗位角色',
    //   dataIndex: 'personCount',
    // },
    // {
    //   title: '电话',
    //   dataIndex: 'subDeptCount',
    // },
    // {
    //   title: '操作',
    //   dataIndex: '',
    //   render: () => (
    //     <span>
    //       <a href="javascript:;">编辑</a>
    //       <a href="javascript:;">删除</a>
    //     </span>
    //   ),
    // },
  ],
  /**
   * userId: string 用户id
   * userName: string 用户名称
   * roleSign: string 角色id
   * roleName: string角色名
   * phone: string 电话
   */
  tableId: setNanoId({ str: 'tableKey' }),
  list: [],
  // table选中项的userid数组集合，
  selectedRowKeys: [],
  userDetails: [], // 用户信息信息 用于modal
  // 加载状态
  spinProps: {
    spinning: false,
    tip: '加载中...',
  },
});

const initState = () => {
  return {
    /**
     * 部门类型列表
     * @param {String} typeName: 部门类别名称
     * @param {String} typeSign: 标志
     */
    deptTypeList: [],
    /**
     * 通过接口获取的部门tree，未转换成antd的tree所要的数据的
     * deptId:部门id String
     * deptName: 部门名称 String
     * deptType： 部门类型 String
     * typeExplain：  String
     * parentId: 父节点id String
     * isRoot： 是否是根节点： 0: 根节点，1：叶子节点
     * subDepts: 子节点列表
     *  --> deptId
     *  --> deptName
     *  --> Root
     *  --> subDepts
     */
    initDeptTreeList: {},
    pageInfo: {
      totalElements: 0,
      totalPages: 1,
      pageSize: 20,
      curPage: 1,
    },
    tableId: setNanoId({ str: 'tableKey' }), // tab的key值，每次删除table中的数据重新获取数据之后，table中会有缓存选中项，当你再次选中一个选项的时候，上次删除的选中项会重新出现
    deptTreeList: [],
    attributeInfos: [], // 原始表头数据
    userData: [], // 原始表数据
    ...initData(),
  };
};

export default {
  namespace: 'countyPersonnel',

  state: initState(),

  effects: {
    // 获取部门类型列表
    *fetchDeptTypeList(_, { call, put }) {
      try {
        // 获取部门类型列表
        const { types } = yield call(getDeptTypeList);

        // // 获取部门tree列表
        const deptTree = yield call(getDeptTree);
        const newDetpTree = yield getDeptTreeFun(deptTree);

        types.unshift({
          typeSign: '',
          typeName: '全部部门类型',
        });

        yield put({
          type: 'save',
          payload: {
            deptTypeList: types,
            initDeptTreeList: deptTree,
            deptTreeList: newDetpTree,
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    *fetchList({ searchParams, actionBtn }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const {
          attributeInfos = [],
          contents: userData,
          totalElements,
          totalPages,
          pageSize,
          curPage,
        } = yield call(getStudentList, searchParams);

        // 设置表头
        const headers = setPersonnelTableHeader({
          attributeInfos,
          other: actionBtn,
        });

        const list = setPersonnelTableData({ userData });

        yield put({
          type: 'save',
          payload: {
            list,
            attributeInfos,
            userData,
            columns: headers,
            tableId: setNanoId({ str: 'tableKey' }),
            pageInfo: {
              totalElements,
              totalPages,
              pageSize,
              curPage,
            },
            selectedRowKeys: [],
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 批量删除
    *fetchDelBatchs({ payload, callback, deleteType }, { call, put, select }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '删除中...' });
        const { selectedRowKeys, tableId } = yield select(state => state.countyPersonnel);
        yield call(delBatchs, payload);

        let newSelectedRowKeys = [];
        let newTableId = setNanoId({ str: 'tableKey' });

        if (deleteType === 1) {
          const { userIds } = payload;
          newTableId = tableId;
          const index = selectedRowKeys.indexOf(userIds[0]);
          if (index > -1) {
            selectedRowKeys.splice(index, 1);
            newSelectedRowKeys = selectedRowKeys;
          }
        }

        yield put({
          type: 'save',
          payload: {
            selectedRowKeys: newSelectedRowKeys,
            tableId: newTableId,
          },
        });

        message.success('删除人员成功');

        if (callback) {
          callback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 批量加入部门
    *batchAddDept({ searchParams }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        yield call(batchAddDept, searchParams);

        message.success('加入成功');
        yield setSpinProps({
          put,
          showSelectUserModal: false,
          selectedRowKeys: [],
          tableId: setNanoId({ str: 'tableKey' }),
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 获取下级部门列表数据
    *fetchSearch({ searchParams }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { rows } = yield call(searchList, searchParams);

        yield put({
          type: 'save',
          payload: {
            list: rows,
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 批量导入老师
    *fetchUploadTeacher({ params, callback }, { put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '导入中...' });

        const { taskId, titles } = params;

        yield put({
          type: 'countyTeacherUpload/saveUploadData',
          payload: { titles, taskId },
        });

        message.success('导入成功');

        if (callback) {
          yield callback(taskId);
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 批量导入学生
    *fetchUploadStudnt({ params, callback }, { put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '导入中...' });

        const { titles, taskId } = params;
        yield put({
          type: 'countyStudentUpload/save',
          payload: { titles, taskId },
        });

        message.success('导入成功');

        if (callback) {
          callback(taskId);
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 点击用户名称  获取用户详情  弹出用户信息modal
    *fetchUserDetils({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载...' });

        const data = yield call(userDetails, {
          ...params,
        });

        yield put({
          type: 'save',
          payload: { showUserDetailsModal: true, userDetails: data },
        });
        yield setSpinProps({ put });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
    resetData(state) {
      return { ...state, ...initData() };
    },
  },
};
